<template>
  <div class="note-list-page">
    <div class="page-title">
      <div>小红书列表</div>
      <div class="add" @click="dialogRedBook = true">+ 添加小红书</div>
    </div>
    <el-table :data="notes" border stripe size="small">
      <el-table-column v-for="col in columns" :prop="col.prop" :key="col.id" :label="col.label" :width="col.width"></el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="deleteItem(scope.$index,scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="g-page-area">
      <el-pagination @current-change="currentPageChange" :current-page.sync="page" :page-size="15" layout="total, prev, pager, next" :total="total" background></el-pagination>
    </div>
    <el-dialog title="添加一条小红书" :visible.sync="dialogRedBook" width="30%">
      <addRedBook @success="handleCreateSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import addRedBook from '@/components/admin/redbook/Add.vue'
export default {
  components: {
    addRedBook
  },
  data () {
    return {
      notes: [{}],
      total: 0,
      page: 1,
      columns: [
        { id: 1, prop: 'id', label: '编号', width: '100px' },
        { id: 2, prop: 'title', label: '标题', width: '' },
        { id: 3, prop: 'create_time', label: '创建时间', width: '150px' }
      ],
      dialogRedBook: false
    }
  },
  methods: {
    handleCreateSuccess () {
      this.getnotes(this.page)
      this.dialogRedBook = false
    },
    currentPageChange (page) {
      this.getnotes(page)
    },
    deleteItem (index, id) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(index, id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleDelete (index, id) {
      const that = this
      that.axios.delete('admin/note/' + id).then(function (resp) {
        if (resp.data.code === 0) {
          that.$message.success('删除成功')
          that.notes.splice(index, 1)
          that.total = that.total - 1
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    },
    getnotes (page) {
      const that = this
      that.axios.get('admin/note', { params: { page } }).then(function (resp) {
        if (resp.data.code === 0) {
          that.total = resp.data.total
          that.notes = resp.data.notes
        }
      })
    }
  },
  mounted () {
    this.getnotes(1)
  }
}
</script>

<style scoped>
.note-list-page{
  max-width: 1200px;
  margin: auto;
  box-sizing: border-box;
  padding: 50px 20px;
}
.page-title{
  max-width: 1200px;
  margin: 10px auto 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #DCDFE6;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.add{
  font-size: 14px;
  cursor: pointer;
  color: #409EFF;
}
</style>
